import { RequestConfig } from '@/interface'

const PRIFX = 'fpgl/report/'
const billingStatisticsConfig: RequestConfig = {
  // 代办事项发票统计
  fpkjReport: {
    url: `${PRIFX}fpkjReport`,
    method: 'post'
  },
  // 授信额度统计
  sxedReport: {
    url: `${PRIFX}sxedReport`,
    method: 'post'
  }
}
export default billingStatisticsConfig
